class searchView {
  #parentElement = document.querySelector('.search');
  #searchBtn = document.querySelector('.search__btn');

  getQuery() {
    return document.querySelector('.search__field').value;
  }
  addHandlerSearch(handler) {
    this.#searchBtn.addEventListener('click', function (e) {
      e.preventDefault();
      handler();
    });
  }
}
export default new searchView();
